import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.style.opacity = "0"
    this.element.style.transition = "opacity 0.3s ease-in-out"

    // Small delay to ensure the opacity transition occurs
    setTimeout(() => {
      this.element.style.opacity = "1"
    }, 50)
  }
}
